(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/shared/game-analysis-filter-utils.js') >= 0) return;  svs.modules.push('/components/content/shared/game-analysis-filter-utils.js');
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var validTypes = ['cnt:authorProfile', 'cnt:drawAnalysis', 'cnt:gameAnalysis'];
var excludedRootVariables = ['properties', 'parentId', 'parentName', 'rank', 'version'];
var excludedAuthorProfileVariables = [].concat(excludedRootVariables);
var excludedGameAnalysisVariables = [].concat(excludedRootVariables);
var rootRenamePairs = [{
  from: 'domainCategories',
  to: 'gameInfo'
}];
var authorProfileRenamePairs = [{
  from: 'domainCategories',
  to: 'authorInfo'
}];
var gameAnalysisRenamePairs = [{
  from: 'domainCategories',
  to: 'gameAnalysisInfo'
}];

var typeIsValid = function typeIsValid(result) {
  return result ? validTypes.indexOf(result.contentType) > -1 : result;
};

var deepCopyOf = function deepCopyOf(obj) {
  return obj ? JSON.parse(JSON.stringify(obj)) : obj;
};

var excludeVariableIn = function excludeVariableIn(section, variableName) {
  if (section) {
    var copyOfSection = deepCopyOf(section);
    delete copyOfSection[variableName];
    return copyOfSection;
  }
};

var renameVariableIn = function renameVariableIn(json, renamePair) {
  if (json) {
    var jsonStringSplit = JSON.stringify(json).split(renamePair.from);
    var hasVariable = function hasVariable(stringSplit) {
      return stringSplit.length !== 1 || stringSplit[0] !== '';
    };
    return hasVariable(jsonStringSplit) ? JSON.parse(jsonStringSplit.join(renamePair.to)) : null;
  }
};

var kebabToCamel = function kebabToCamel(inString) {
  return inString.replace(/([-_][a-z])/g, function (matches) {
    return matches.toUpperCase().replace('-', '').replace('_', '');
  });
};

var processDomainCategoriesFrom = function processDomainCategoriesFrom(domainCategories) {
  if (Array.isArray(domainCategories)) {
    var copyOfDomainCategories = deepCopyOf(domainCategories);
    var processedDomainCategories = {};
    copyOfDomainCategories.forEach(function (domainCategory) {
      var value = domainCategory.split('/')[1];
      var keyName = kebabToCamel(domainCategory.split('svs-domain-')[1].split('/')[0]);
      if (Array.isArray(processedDomainCategories[keyName])) {
        processedDomainCategories[keyName].push(value);
      } else {
        processedDomainCategories[keyName] = [value];
      }
    });
    return processedDomainCategories;
  }
  return domainCategories;
};

var processAuthorProfileFrom = function processAuthorProfileFrom(authorProfile) {
  authorProfile.domainCategories = processDomainCategoriesFrom(authorProfile.domainCategories);
  excludedAuthorProfileVariables.forEach(function (excludedVariable) {
    authorProfile = excludeVariableIn(authorProfile, excludedVariable);
  });
  return authorProfile;
};

var processGameAnalysis = function processGameAnalysis(gameAnalysis) {
  var processed = _objectSpread(_objectSpread({}, gameAnalysis), {}, {
    domainCategories: processDomainCategoriesFrom(gameAnalysis.domainCategories),
    eventNumber: gameAnalysis.properties.cnt_eventNumber,
    gamePredictions: JSON.parse(gameAnalysis.properties.cnt_gamePrediction)
  });
  excludedGameAnalysisVariables.forEach(function (excludedVariable) {
    delete processed[excludedVariable];
  });
  return processed;
};

var processGameAnalysesFrom = function processGameAnalysesFrom(gameAnalyses) {
  if (gameAnalyses) {
    var processedGameAnalyses = [];
    gameAnalyses.forEach(function (gameAnalysis) {
      processedGameAnalyses.push(processGameAnalysis(gameAnalysis));
    });
    return processedGameAnalyses;
  }
};

var processRenamingOn = function processRenamingOn(result) {
  authorProfileRenamePairs.forEach(function (renamePair) {
    result.authorProfile = renameVariableIn(result.authorProfile, renamePair);
  });
  gameAnalysisRenamePairs.forEach(function (renamePair) {
    result.gameAnalysis = renameVariableIn(result.gameAnalysis, renamePair);
  });
  rootRenamePairs.forEach(function (renamePair) {
    result = renameVariableIn(result, renamePair);
  });
  return result;
};
var exportPayload = {
  deepCopyOf: deepCopyOf,
  typeIsValid: typeIsValid,
  processAuthorProfileFrom: processAuthorProfileFrom,
  processGameAnalysis: processGameAnalysis,
  processGameAnalysesFrom: processGameAnalysesFrom,
  processDomainCategoriesFrom: processDomainCategoriesFrom,
  excludeVariableIn: excludeVariableIn,
  excludedRootVariables: excludedRootVariables,
  processRenamingOn: processRenamingOn,
  validTypes: validTypes
};
if (svs.isServer) {
  module.exports = exportPayload;
} else {
  svs.content.shared.filters.gameAnalysisFilter.gameAnalysisFilterUtils = exportPayload;
}

 })(window);